<div class="header">
	<div class="block-1" [routerLink]="['/']">
		<mat-icon class="icon" svgIcon="logo-header"></mat-icon>
	</div>
	<div class="block-2">
		<a href="javascript:void(0)"><img src="./assets/images/header/h-google.png" alt="Google Icon"></a>
		<a href="javascript:void(0)"><img src="./assets/images/header/h-apple.png" alt="App Store Icon"></a>
	</div>
</div>
<div id="login-container">
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 form">
		<div class="titles">
			<h3 class="reset-password">Reset Password?</h3>
			<p class="message"></p>
		</div>

		<div class="form-container">
			<!--Login with Email-->
			<form [formGroup]=form (autocomplete)="'false'" (submit)="onSubmit(form)">
				<div class="form-group">
					<label>Password<sup class="error">*</sup></label>
					<app-input [type]="'password'" (onChangeEvent)="form.controls.password.setValue($event)"
						(onFocusOutEvent)="markTouchedAndDirty($event, 'password')"
						[value]="form.value.password"></app-input>
					<p class="error"
						*ngIf="form.get('password')?.invalid && (form.get('password')?.dirty || form.get('password')?.touched)">
						Please enter valid Password
					</p>
					<ul class="help-text">
						<li>Should contain minimum 8 characters</li>
						<li>Should contain atleast 1 uppercase & lowercase character</li>
						<li>Should contain atleast 1 special character</li>
						<li>Should contain atleast 1 number</li>
					</ul>
				</div>

				<div class="form-group">
					<label>Token<sup class="error">*</sup></label>
					<ng-otp-input #ngOtpInput (onInputChange)="doValidateOTP($event)"
						[config]="otpConfig"></ng-otp-input>
					<p class="error"
						*ngIf="form.get('resetToken')?.invalid && (form.get('resetToken')?.dirty || form.get('resetToken')?.touched)">
						Please enter valid token
					</p>
				</div>
				<div class="col-12 text-center login-btn-block">
					<button type="submit" mat-button class="btn btn-block">Submit</button>
				</div>
			</form>
		</div>
	</div>
	<div class="col-xs-12 col-sm-12 col-md-6 px-0 image-container">
		<img src="assets/images/side-image.png" alt="brand-image" />
	</div>
</div>
<div class="footer">
	<div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 px-0">
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 block-1">
			<p>Already have account?
				<a href="javascript:void(0)" [routerLink]="['/login']">
					<strong>&nbsp;Login</strong>
				</a>
			</p>
		</div>
		<div class="col-sm-12 col-xs-12 col-md-6 col-lg-6 text-right block-2">
			<a [routerLink]="['/termsandconditions']">Terms & Conditions</a>
			<span>|</span>
			<a [routerLink]="['/privacypolicy']">Privacy Policy</a>
		</div>
	</div>
</div>